<template>
  <div
    v-if="!block.hidden"
    :id="containerId"
    class="preview-block-editor"
  >
    <BlockEditor
      :component-data="componentData"
      :type="block.type"
      :preview="true"
    />
  </div>
</template>

<script>
import BlockEditor from './BlockEditor.vue'

export default {
  components: {
    BlockEditor,
  },
  props: {
    block: {
      type: Object,
      default: null,
    },
    slideId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      blockInstance: null,
    }
  },

  computed: {
    componentData() {
      return {
        ...this.block,
        slideId: this.slideId,
        blockId: this.block.id,
      }
    },
    containerId() {
      return `container-${this.block.id}`
    },
  },

}
</script>

<style lang="scss" scoped>
.preview-block-editor {
  width: 0px;
  height: 0px;
  img {
    max-width: inherit;
  }
  .element-editor{
    &.preview-block-editor{
      cursor: default;
    }
    position: absolute;
    font-size: 2em;
  }

  &::v-deep .rich-text-editor {
    overflow: hidden !important;
    font-size: 2.25em !important;

    ol,
    ul {
      padding-left: 50px;
      margin: 0;
    }

    img {
      display: inline-block;
    }

    ol,
    ul {
      list-style-position: unset;
      list-style-image: unset;
      list-style-type: revert;
    }

    ul {
      list-style-type: disc;
    }
    ul ul {
      list-style-type: circle;
    }
  }

}

</style>
